import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    (async () => {
      if (!session_id) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const user = await exchangeSession(session_id);
        setUser(user);
        // Clean the hash and route by role
        window.history.replaceState(null, "", window.location.pathname);
        const dest = user.role === "admin" ? "/admin" : "/account";
        navigate(dest, { replace: true, state: { user } });
      } catch {
        navigate("/login?error=1", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1C1A17] text-white">
      <div className="text-center">
        <div className="font-head text-2xl font-medium">Signing you in…</div>
        <div className="mt-2 text-white/50 text-sm">One moment.</div>
      </div>
    </div>
  );
}
